"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledProductImageWrapper = exports.StyledProductDetailsAttributesWrapper = exports.StyledProductDetailsWrapper = exports.StyledDialogContentWrapper = exports.StyledDialog = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
const generic_1 = require("../../generic");
exports.StyledDialog = (0, styled_components_1.default)(generic_1.ActionDialog) `
  .MuiDialog-paper {
    min-height: 40vh;
    height: calc(100% - 170px)
  }

  && .MuiDialogContent-root {
    flex-direction: column;
    padding: 0;
  }

 && .MuiDialogTitle-root {
    font-size: .875rem;
    border-bottom: 1px solid ${ui_components_1.baseColors.border};
    padding: ${({ theme }) => theme.spacing(2)}; 
  }

  && .switch-product-buttons {
    position: fixed;
    justify-content: center;
    width: 100%;
    bottom: ${({ theme }) => theme.spacing(2.5)};
    left: 0;
    gap: ${({ theme }) => theme.spacing(5)};

    text-transform: uppercase;

    button {
      background: ${ui_components_1.baseColors.white};

      &:last-child {
        margin-left: 0;
      }
    }
  }
`;
exports.StyledDialogContentWrapper = styled_components_1.default.div `
  display: grid;
  grid-template-columns: minmax(315px, 35%) auto;
  flex: 1;
`;
exports.StyledProductDetailsWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  background: ${ui_components_1.baseColors.background000};
  gap: ${({ theme }) => theme.spacing(1)};
  padding: ${({ theme }) => theme.spacing(2.5, 2)};
`;
exports.StyledProductDetailsAttributesWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
  padding: ${({ theme }) => theme.spacing(2.5, 2)};
`;
exports.StyledProductImageWrapper = styled_components_1.default.div `
  max-width: 100px;
`;
